<template>
    <div class="us_app">
        <section class="user_section">
            <div class="title jc">
                <h2>내 처방관리</h2>   
            </div>
            <article class="view cmnity">
                <div class="search_box" style="flex-wrap: wrap">
                    <p class="w100 mb20">
                        총 처방수
                        <strong> {{ searchInfo.pageInfo.totPage }} </strong>건
                    </p>

                    <div class="flex items-center justify-between w100">
                        <div class="form_inline">
                            <span class="mw100 fwb">처방명</span>
                            <input
                                type="text"
                                class="form_control"
                                placeholder="환자명을 입력하세요."
                                v-model="searchInfo.prescribe_nm"
                            />
                            <span class="mw100 fwb">출전</span>
                            <input
                                type="text"
                                class="form_control"
                                placeholder="환자명을 입력하세요."
                                v-model="searchInfo.prescribe_nm"
                            />
                        </div>
                        <div class="form_inline">
                            <button class="btn btn_md btn_darkbrown" @click="fn_search">검색</button>
                            <button
                                class="btn btn_md btn_brown"
                                @click="fn_move_reg_page"
                            >
                                내 처방 등록
                            </button>
                        </div>
                    </div>
                </div>



                <div class="tab_contents">
                    <div class="lay_left">
                        <div class="table_list">
                            <table class="list">
                                <colgroup>
                                    <col width="60">
                                    <col width="45%">
                                    <col width="35%">
                                    <col width="160">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>처방명</th>
                                        <th>출전</th>
                                        <th>등록일시</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="myPrescribeList.length == 0">
                                        <td colspan="4"><span>데이터가 없습니다.</span></td>
                                    </tr>
                                    <tr v-for="(item, index) in myPrescribeList" :key="index" @click="fn_move_dtl_page(item.my_prescribe_seq)">
                                        <td><span>{{ searchInfo.pageInfo.totPage - ((searchInfo.pageInfo.page - 1) * searchInfo.pageInfo.pageSize) - index }}</span></td>
                                        <td><span>{{ item.prescribe_nm }}</span></td>
                                        <td><span>{{ item.prescribe_source }}</span></td>
                                        <td><span>{{ item.prescribe_dt }}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <Pagination :pageInfo="searchInfo.pageInfo" @clickPage="movePage" v-show="pagingShow"/>
                    </div>
                </div>
            </article>
        </section>
    </div>
</template>

<script>
import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import Pagination from "@/components/AdminPagination.vue"

export default {
    name: 'MyPrescribeList',
    mixins: [commonUtil],
    components: {
      Pagination
    },
    data() {
      return {
        searchInfo : {
            clinic_doctor_id : '',
            prescribe_nm : '',
            pageInfo : {
                page : 1,
                pageSize : 10,
                totPage : 0
            }                
        },
		    pagingShow : false,
            myPrescribeList: []
        }
    },
    created(){
        //this.fn_search();
        this.searchInfo.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
    },
    mounted(){
        this.fn_search();
    },
    methods : {
        fn_search(){
            axios
                .post("/api/user/myPrescribe/getMyPrescribeList", this.searchInfo)
                .then((res) => {
                    console.log("@@@@ res : %o",res);
                    this.myPrescribeList = res.data.myPrescribeList;

                    console.log("@@@@ myPrescribeList : %o",this.myPrescribeList);

                    this.searchInfo.pageInfo.totPage = res.data.totCnt;
                    
                    if(this.searchInfo.pageInfo.totPage> 0){
                        this.pagingShow = true;                          
                    }                        

                })
                .catch((err) => console.log(err));
        },
        movePage(page){
            console.log("@@@@@ page : "+page);
            this.searchInfo.pageInfo.page = page;
            this.fn_search();
        },
        fn_move_dtl_page(seq){
            this.$store.dispatch('detailSearchInfo/setSearchId', seq); 
            this.$router.push({ name : 'MyPrescribeDtl'});
        },
        fn_move_reg_page(seq){
            this.$router.push({ name : 'MyPrescribeWrite'});
        },
    }
}
</script>
